// src/services/groupTicketDesignApi.js
import environment from "../environments/environment";

const LS_PREFIX = "qe_group_ticket_design:";

export async function getGroupTicketDesign(groupId) {
  if (!groupId) {
    console.warn("getGroupTicketDesign: missing groupId");
    return null;
  }

  const response = await fetch(
    `${environment.apiUrl}/ticket/groupDesign/${groupId}`,
    {
      method: "GET",
      credentials: "include",
    },
  );

  const result = await response.json();
  if (result?.data?.design) {
    try {
      localStorage.setItem(
        LS_PREFIX + `${groupId}`,
        JSON.stringify(result.data.design),
      );
    } catch (e) {
      console.warn("localStorage setItem failed (quota exceeded):", e);
    }
    return result.data.design;
  }
  return null;
}

export async function getDefaultGroupTicketDesign() {
  const response = await fetch(
    `${environment.apiUrl}/ticket/groupDesign/default`,
    {
      method: "GET",
      credentials: "include",
    },
  );

  const result = await response.json();
  return result?.data?.design || result?.design || null;
}

export async function saveGroupTicketDesign(groupId, design) {
  if (!groupId) {
    throw new Error("saveGroupTicketDesign: missing groupId");
  }

  const response = await fetch(
    `${environment.apiUrl}/ticket/groupDesign/save`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        group_id: groupId,
        design,
      }),
    },
  );

  const result = await response.json();
  return result;
}

export async function loadGroupDesign(groupId) {
  try {
    const design = await getGroupTicketDesign(groupId);
    if (design) {
      const key = `${groupId}`;
      try {
        localStorage.setItem(LS_PREFIX + key, JSON.stringify(design));
      } catch (e) {
        console.warn("localStorage setItem failed (quota exceeded):", e);
      }
      return design;
    }
  } catch (e) {
    console.error("Failed to load group ticket design from API:", e);
  }

  const key = `${groupId}`;
  const raw = localStorage.getItem(LS_PREFIX + key);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export async function saveGroupDesign(groupId, design) {
  if (!groupId) {
    throw new Error("saveGroupDesign: missing groupId");
  }

  try {
    const result = await saveGroupTicketDesign(groupId, design);
    const key = `${groupId}`;
    try {
      localStorage.setItem(LS_PREFIX + key, JSON.stringify(design));
    } catch (e) {
      console.warn("localStorage setItem failed (quota exceeded):", e);
    }
    return result;
  } catch (e) {
    console.error("Failed to save group ticket design to API:", e);
    throw e;
  }
}
